import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/projects';
const URL = BASE_URL + '/projects-cost';

const getProjectCostList = async (keyword, page, limit) => {
  try {
    const response = await axios.get(URL, {
      params: {
        keyword,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const createProjectCost = async (data) => {
  try {
    const result = await axios.post(URL, data);
    console.log(result);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the project cost.');
    }
  }
};

const updateProjectCost = async (id, data) => {
  try {
    await axios.put(`${URL}/${id}`, data);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error updating the project cost.');
    }
  }
};

const deleteProjectCost = async (id) => {
  try {
    await axios.delete(`${URL}/${id}`);
  } catch (error) {
    console.log(error);
  }
};

const getProjectCostById = async (id) => {
  try {
    const result = await axios.get(`${URL}/${id}`);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export {
  getProjectCostList,
  createProjectCost,
  updateProjectCost,
  deleteProjectCost,
  getProjectCostById,
};
